import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={20}
    height={21}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={10} cy={10.5} r={10} fill="#fff" />
    <path
      d="M16.18 13.666V12.46h.452a.921.921 0 0 0 .904-.905v-2.11a.921.921 0 0 0-.904-.904h-.452V7.335a.921.921 0 0 0-.905-.905H3.217c-.487 0-.754.452-.754.938v6.264c0 .487.267.938.754.938h12.058a.92.92 0 0 0 .905-.904Zm-12.511 0c-.044 0-.15-.107-.15-.151V7.636c0-.044.106-.15.15-.15h11.305c.044 0 .15.106.15.15v5.879c0 .044-.106.15-.15.15H3.669Zm.15-5.88v5.578h11.004v-5.54L3.82 7.787Z"
      fill="#FA3C30"
    />
    <path
      d="M16.18 13.666V12.46h.452a.921.921 0 0 0 .904-.905v-2.11a.921.921 0 0 0-.904-.904h-.452V7.335a.921.921 0 0 0-.905-.905H3.217c-.487 0-.754.452-.754.938v6.264c0 .487.267.938.754.938h12.058a.92.92 0 0 0 .905-.904Zm-12.511 0c-.044 0-.15-.107-.15-.151V7.636c0-.044.106-.15.15-.15h11.305c.044 0 .15.106.15.15v5.879c0 .044-.106.15-.15.15H3.669Z"
      fill="#222"
    />
  </svg>
);

export default SvgComponent;
